<script>
import SearchSuggestionsList from './components/SearchSuggestionsList.vue';
import { fetchSuggestions } from '../search-suggestions/api';
import { getTranslate } from '../../utils/translations';
import { serializeSuggestions } from '../search-suggestions/utils/api-util';

const translate = getTranslate(window.searchSuggestionsTranslations);

export default {
    name: 'SearchEmptyListSuggestions',
    provide: {
        $t: (key) => translate(key)
    },
    components: {
        SearchSuggestionsList
    },
    mounted() {
        const searchInput = document.querySelector('#search');

        this.searchInputValue = searchInput.value;
        this.getSearchData();
    },
    data() {
        return {
            searchInputValue: '',
            suggestions: []
        };
    },
    methods: {
        async getSearchData() {
            const payload = await fetchSuggestions(this.searchInputValue);
            const suggestions = serializeSuggestions(payload);

            this.suggestions = suggestions;
        }
    }
};
</script>

<template>
    <div class="empty-list-suggestions">
        <SearchSuggestionsList
            v-if="suggestions.length"
            :search-string="searchInputValue"
            :suggestions="suggestions"
        />
    </div>
</template>
